(function aos($, Drupal) {
  Drupal.behaviors.rutherford_aos = {
    attach() {
      AOS.init({
        once: true,
        duration: 400,
      });
    },
  };
})(jQuery, Drupal);
